<template>
	<GoToAddOnAppContent
		v-if="needToPassPlacementId !== null"
		:app="app"
		:credentialsId="credentialsId"
		:placementId="needToPassPlacementId ? placementId : placementVersionId"
		:contextId="contextId"
		:serviceWorkspace="serviceWorkspace"
		:addOnUrl="addOnUrl"
		v-bind="$attrs"
		v-on="$listeners"
	/>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import GoToAddOnAppContent from './GoToAddOnAppContent.vue';
import { getService } from '@/store/modules/apps/getters';
import { getAccountConnection } from '@/store/modules/credentials/getters';
import AppService from '@/utils/AppService';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
import { getPlacement } from '@/store/modules/placements/getters';
const doesNeedToPassPlacementId = () => ExtensionCommunicationService.doesSupportsNewPlacementRelations();
export default {
	name: 'GoToAddOnAppContentDataProvider',
	props: {
		credentialsId: { type: Number, required: false }, // required for all cases but authorization scheme === 'none'
		placementId: { type: Number },
		placementVersionId: { type: Number },
		contextId: { type: Number, required: false },
	},
	components: { GoToAddOnAppContent },
	computed: {
		...mapGettersShorthand({ getService, getAccountConnection, getPlacement }),
		placement() {
			return this.getPlacement(this.placementId);
		},
		appId() {
			return this.placement.service;
		},
		app() {
			return this.getService(this.appId);
		},
		credentials() {
			return this.getAccountConnection(this.credentialsId);
		},
		serviceWorkspace() {
			return this.credentials?.service_workspace;
		},
		addOnUrl() {
			return `https://${AppService.getAppMainHost(this.app)}/`;
		},
	},
	async created() {
		this.needToPassPlacementId = await doesNeedToPassPlacementId();
	},
	data() {
		return {
			needToPassPlacementId: null,
		};
	},
};
</script>

<style lang="scss" scoped></style>
